<template>
    <ui-icon v-bind:style="{fontSize:'1.5em'}" class="icon" backgroundColor="#DDDDDD" color="#999999" icon="bars"></ui-icon>
</template>

<script>

import UiIcon from '../UiIcon.vue'

export default {
  name: 'icon-button-fake',
  components:{
    UiIcon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .icon{
    opacity:0;
  }
</style>
